import { action, Action } from 'easy-peasy';

export interface ISearchInfoModel {
    destroy: Action<ISearchInfoModel>;
    // 0 为搜索，1 为非搜索
    is_search: string;
    // 分类
    class: string;
    // 关键词
    query: string;
    // 算法
    scm: string;

    setISearchInfo: Action<
        ISearchInfoModel,
        {
            is_search: string;
            // 分类
            class: string;
            // 关键词
            query: string;
            // 算法
            scm: string;
        }
    >;
    setIsSearch: Action<ISearchInfoModel, string>;
    setClass: Action<ISearchInfoModel, string>;
    setQuery: Action<ISearchInfoModel, string>;
    setScm: Action<ISearchInfoModel, string>;
}
export const searchModel: ISearchInfoModel = {
    destroy: action((state) => {
        state.is_search = '1';
        state.class = '';
        state.query = '';
        state.scm = '';
    }),
    is_search: '1',
    class: '',
    query: '',
    scm: '',
    setISearchInfo: action((state, searchInfo) => {
        state.is_search = searchInfo.is_search || '';
        state.class = searchInfo.class || '';
        state.query = searchInfo.query || '';
        state.scm = searchInfo.scm || '';
    }),
    setIsSearch: action((state, isSearch) => {
        state.is_search = isSearch;
    }),
    setClass: action((state, classes) => {
        state.class = classes;
    }),
    setQuery: action((state, query) => {
        state.query = query;
    }),
    setScm: action((state, scm) => {
        state.scm = scm;
    }),
};
